// AEの選択肢の「指定なし」（LP004・005では学歴・現在の状況・都道府県に0が固定で入る）
const notSpecified = '指定なし'

// PrefsMixin（1〜47）に無い都道府県コード
const aePrefExtras = [
  { id: 0, name: notSpecified },
  { id: 48, name: '海外' }
]

export default {
  methods: {
    sendAeForm: function (formData, customer) {
      if (!this.aeApi.isSend) {
        return
      }
      // AE送信に失敗しても、Kairos送信・画面遷移は止めない
      try {
        // axios(XHR)では keepalive・no-cors を指定できないため fetch を使う
        // keepalive: 直後のKairosフォーム送信で画面遷移しても送信を続ける
        // no-cors: レスポンスは参照しない／credentials: AEの訪問者Cookieを送る
        fetch(this.aeApi.url.action, {
          method: 'POST',
          mode: 'no-cors',
          credentials: 'include',
          keepalive: true,
          body: this.getAeFormParams(formData, customer)
        }).catch(() => {})
      } catch (e) {}
    },
    getAeFormParams: function (formData, customer) {
      const params = new URLSearchParams()
      params.append('f_item_mail', formData.email || '')
      params.append('f_item_mobile', `${formData.tel1}${formData.tel2}${formData.tel3}`)
      params.append('f_item_name_last', formData.name_sei || '')
      params.append('f_item_name_first', formData.name_mei || '')
      params.append('f_item_name_kana_last', formData.kana_sei || '')
      params.append('f_item_name_kana_first', formData.kana_mei || '')
      params.append('f_item_birthdate', this.displayBirthdayForAe(formData))
      params.append('f_item_address_pref', this.displayPrefForAe(formData.pref))
      params.append('f_item_title', this.displayGenderForAe(formData.sex))
      params.append('f_item_division', this.displayNowStatusForAe(formData.now_status))
      params.append('f_item_company_name', this.displayCareerForAe(formData.career))
      params.append('f_item_workplace', this.displayPrefForAe(formData.workplace))
      params.append('f_item_hope_work_timing', this.displayHopeWorkTimingForAe(formData.hope_work_timing))
      params.append('f_item_full_time_period', this.displayFullTimeWorkerPeriodForAe(formData.full_time_worker_period))
      params.append('f_item_hrbc_no', customer.hrbc ? customer.hrbc : '')
      params.append('f_item_registration_source', customer.referer ? customer.referer : formData.referer)
      params.append('gclid', this.getGclidForAe())
      return params
    },
    displayBirthdayForAe: function (formData) {
      if (formData.birth_year && formData.birth_month && formData.birth_day) {
        return `${formData.birth_year}-${this.toDoubleDigits(formData.birth_month)}-${this.toDoubleDigits(formData.birth_day)}`
      }
      return ''
    },
    displayPrefForAe: function (pref) {
      if (pref === null || pref === '') {
        return ''
      }
      const prefs = aePrefExtras.concat(this.prefs)
      for (let key in prefs) {
        if (prefs.hasOwnProperty(key)) {
          if (prefs[key].id === pref) {
            return prefs[key].name
          }
        }
      }
      return ''
    },
    displayGenderForAe: function (gender) {
      return this.displayGender(gender) || notSpecified
    },
    displayCareerForAe: function (career) {
      if (career === null || career === '') {
        return ''
      }
      if (career === 0) {
        return notSpecified
      }
      for (let key in this.careers) {
        if (this.careers.hasOwnProperty(key)) {
          if (this.careers[key].id === career) {
            return this.careers[key].text
          }
        }
      }
      return ''
    },
    displayNowStatusForAe: function (nowStatus) {
      if (nowStatus === null || nowStatus === '') {
        return ''
      }
      if (nowStatus === 0) {
        return notSpecified
      }
      for (let key in this.nowStatuses) {
        if (this.nowStatuses.hasOwnProperty(key)) {
          if (this.nowStatuses[key].id === nowStatus) {
            return this.nowStatuses[key].text
          }
        }
      }
      return ''
    },
    displayHopeWorkTimingForAe: function (hopeWorkTiming) {
      if (hopeWorkTiming === null || hopeWorkTiming === '') {
        return ''
      }
      for (let key in this.hopeWorkTimingItems) {
        if (this.hopeWorkTimingItems.hasOwnProperty(key)) {
          if (this.hopeWorkTimingItems[key].value === hopeWorkTiming) {
            return this.hopeWorkTimingItems[key].label
          }
        }
      }
      return ''
    },
    displayFullTimeWorkerPeriodForAe: function (fullTimeWorkerPeriod) {
      if (fullTimeWorkerPeriod === null || fullTimeWorkerPeriod === '') {
        return ''
      }
      for (let key in this.fullTimeWorkerPeriods) {
        if (this.fullTimeWorkerPeriods.hasOwnProperty(key)) {
          if (this.fullTimeWorkerPeriods[key].value === fullTimeWorkerPeriod) {
            return this.fullTimeWorkerPeriods[key].label
          }
        }
      }
      return ''
    },
    getGclidForAe: function () {
      try {
        return sessionStorage.getItem(this.aeApi.storageKey.gclid) || ''
      } catch (e) {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/AccountEngagementMixin.js